import { connect } from 'react-redux';

import { GroupsList } from './GroupsList';
import { IAppState } from '../../../../store';

export const GroupsListContainer = connect((state: IAppState) => ({ groups: state.categoriesGroups }))(GroupsList);
